import React from 'react';
import Image from '../../../components/AppImage';

const AuthorBio = () => {
  const author = {
    name: "Dr. Sarah Kouassi",
    title: "Expert IA & Transformation Digitale",
    company: "CRF PERFECTION",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f6f729fa-1763296915319.png",
    alt: "Portrait professionnel de Dr. Sarah Kouassi, experte en intelligence artificielle et transformation digitale chez CRF PERFECTION",
    bio: "Docteure en Intelligence Artificielle avec plus de 10 ans d'expérience dans la transformation digitale des entreprises africaines. Spécialisée dans l'implémentation de solutions IA pour l'industrie automobile, Sarah a accompagné plus de 50 entreprises dans leur digitalisation. Elle est également formatrice certifiée et conférencière internationale sur les enjeux de l'IA en Afrique.",
    expertise: [
    "Intelligence Artificielle",
    "Machine Learning",
    "Transformation Digitale",
    "Industrie Automobile",
    "Formation & Conseil",
    "Innovation Africaine"],

    achievements: [
    { label: "Entreprises Accompagnées", value: "50+" },
    { label: "Années d\'Expérience", value: "10+" },
    { label: "Projets IA Réalisés", value: "120+" },
    { label: "Formations Dispensées", value: "200+" }],

    certifications: [
    "Ph.D. Intelligence Artificielle - MIT",
    "Certified AI Professional - Stanford",
    "Digital Transformation Leader - Harvard",
    "ISO 27001 Lead Auditor"],

    publications: [
    {
      title: "L\'IA au Service du Développement Africain",
      type: "Livre",
      year: "2024"
    },
    {
      title: "Machine Learning pour l\'Automobile",
      type: "Recherche",
      year: "2023"
    },
    {
      title: "Transformation Digitale en Afrique",
      type: "Article",
      year: "2023"
    }],

    social: {
      linkedin: "#",
      twitter: "#",
      email: "sarah.kouassi@crfperfection.com"
    }
  };

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-blue-100 text-blue-800 text-sm font-medium mb-4">
            <span className="w-2 h-2 bg-blue-500 rounded-full mr-2"></span>
            À Propos de l'Auteure
          </div>
        </div>

        {/* Author Profile */}
        <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
          {/* Header Section */}
          <div className="bg-gradient-to-r from-purple-600 to-blue-600 p-8 text-white">
            <div className="flex flex-col md:flex-row items-center space-y-6 md:space-y-0 md:space-x-8">
              <div className="flex-shrink-0">
                <Image
                  src={author?.image}
                  alt={author?.alt}
                  className="w-32 h-32 rounded-full object-cover border-4 border-white/20" />

              </div>
              <div className="text-center md:text-left">
                <h2 className="text-3xl font-bold mb-2">{author?.name}</h2>
                <p className="text-purple-200 text-lg font-semibold mb-2">{author?.title}</p>
                <p className="text-purple-100 mb-4">{author?.company}</p>
                
                {/* Social Links */}
                <div className="flex justify-center md:justify-start space-x-4">
                  <a href={author?.social?.linkedin} className="w-10 h-10 bg-white/20 backdrop-blur-sm rounded-lg flex items-center justify-center hover:bg-white/30 transition-all duration-300">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                    </svg>
                  </a>
                  <a href={author?.social?.twitter} className="w-10 h-10 bg-white/20 backdrop-blur-sm rounded-lg flex items-center justify-center hover:bg-white/30 transition-all duration-300">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
                    </svg>
                  </a>
                  <a href={`mailto:${author?.social?.email}`} className="w-10 h-10 bg-white/20 backdrop-blur-sm rounded-lg flex items-center justify-center hover:bg-white/30 transition-all duration-300">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Content Section */}
          <div className="p-8">
            {/* Bio */}
            <div className="mb-8">
              <h3 className="text-xl font-bold text-gray-900 mb-4">Biographie</h3>
              <p className="text-gray-700 leading-relaxed">
                {author?.bio}
              </p>
            </div>

            {/* Achievements */}
            <div className="mb-8">
              <h3 className="text-xl font-bold text-gray-900 mb-6">Réalisations</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {author?.achievements?.map((achievement, index) =>
                <div key={index} className="text-center bg-purple-50 rounded-xl p-4 border border-purple-200">
                    <div className="text-2xl font-bold text-purple-600 mb-2">{achievement?.value}</div>
                    <div className="text-gray-700 text-sm font-medium">{achievement?.label}</div>
                  </div>
                )}
              </div>
            </div>

            {/* Expertise */}
            <div className="mb-8">
              <h3 className="text-xl font-bold text-gray-900 mb-4">Domaines d'Expertise</h3>
              <div className="flex flex-wrap gap-3">
                {author?.expertise?.map((skill, index) =>
                <span key={index} className="px-4 py-2 bg-blue-100 text-blue-800 rounded-full text-sm font-semibold">
                    {skill}
                  </span>
                )}
              </div>
            </div>

            {/* Certifications & Publications */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {/* Certifications */}
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">Certifications</h3>
                <div className="space-y-3">
                  {author?.certifications?.map((cert, index) =>
                  <div key={index} className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                      <div className="w-8 h-8 bg-green-600 rounded-lg flex items-center justify-center">
                        <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                      </div>
                      <span className="text-gray-700 text-sm font-medium">{cert}</span>
                    </div>
                  )}
                </div>
              </div>

              {/* Publications */}
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">Publications Récentes</h3>
                <div className="space-y-3">
                  {author?.publications?.map((pub, index) =>
                  <div key={index} className="p-4 bg-gray-50 rounded-lg">
                      <div className="flex items-start justify-between">
                        <div>
                          <h4 className="font-semibold text-gray-900 text-sm mb-1">{pub?.title}</h4>
                          <div className="flex items-center space-x-2 text-xs text-gray-600">
                            <span className="px-2 py-1 bg-purple-200 text-purple-800 rounded-full">{pub?.type}</span>
                            <span>{pub?.year}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Contact CTA */}
            <div className="mt-12 bg-gradient-to-r from-purple-100 to-blue-100 rounded-2xl p-8 text-center border border-purple-200">
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                Discutons de Votre Projet IA
              </h3>
              <p className="text-gray-700 mb-6 max-w-2xl mx-auto">
                Vous avez un projet de transformation IA dans l'automobile ? 
                Contactez-moi pour une consultation personnalisée et découvrons ensemble comment 
                l'IA peut révolutionner votre business.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a
                  href={`mailto:${author?.social?.email}`}
                  className="px-8 py-3 bg-gradient-to-r from-purple-600 to-blue-600 text-white font-semibold rounded-lg hover:from-purple-700 hover:to-blue-700 transition-all duration-300">

                  Consultation Gratuite
                </a>
                <a
                  href="/contact"
                  className="px-8 py-3 bg-white border-2 border-purple-600 text-purple-600 font-semibold rounded-lg hover:bg-purple-600 hover:text-white transition-all duration-300">

                  Contacter CRF PERFECTION
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default AuthorBio;